var _rect, _path, _path2, _rect2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 165,
    viewBox: "0 0 270 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 201,
    y: 40,
    width: 132,
    height: 20,
    transform: "rotate(-180 201 40)",
    fill: "#FF865C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M213 56L213 60L57 60L57 56L61 56L61 52L65 52L65 48L69 48L69 40L201 40L201 48L205 48L205 52L209 52L209 56L213 56Z",
    fill: "#FFEA5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M201 68L201 80L69 80L69 68L65 68L65 64L61 64L61 60L209 60L209 64L205 64L205 68L201 68Z",
    fill: "#00DA76"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 201,
    y: 100,
    width: 132,
    height: 20,
    transform: "rotate(-180 201 100)",
    fill: "#0096CE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77 120V116H65V112H61V104H57L57 68H53V64H49V60H45V56H49V52H53V48H57L57 16H61V8H65V4H77V0L193 0L193 4H205V8H209V16H213V48H217V52L221 52V56H225V60H221V64H217V68H213V104L209 104V112H205V116H193V120L77 120ZM69 100V68H65V64H61V60H57V56H61V52H65V48H69L69 20L201 20V48H205V52H209V56H213V60H209V64H205V68H201V100L69 100Z",
    fill: "url(#paint0_linear_14_228)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.958 155.948V159.869H249.654V140H265.958V144.052H270V155.948H265.958ZM261.781 144.183H257.739V156.078H261.781V144.183ZM225.132 140.131H241.435V144.183H233.351V148.105H241.435V152.026H233.351V155.948H241.435V159.869H225.132V140.131ZM212.871 160H204.652V144.183H200.61V140.131H216.913V144.183H212.871V160ZM184.306 140.131H192.525V160H184.306V140.131ZM167.868 155.948H163.826V152.026H159.784V160H151.565V140.131H159.784V144.183H163.826V148.105H167.868V140.131H176.087V160H167.868V155.948ZM139.303 160H127.042V156.078H123V140.261H131.219V156.078H135.261V140.261H143.48V156.078H139.438V160H139.303Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.7335 165V160.902H114V165H97.7335ZM73.2665 160.902V156.803H85.5V160.902H73.2665ZM85.5 152.568H89.533V156.667H85.5V152.568ZM77.434 148.47H85.6344V152.568H77.434V148.47ZM73.2665 144.372H77.2995V148.47H73.2665V144.372ZM89.6674 140.137V144.372H77.434V140.137H89.6674ZM57 156.667V148.333H61.033V156.667H57ZM53.1014 160.902V156.803H57V160.902H53.1014ZM48.934 148.47H53.1014V156.803H48.934V148.47ZM44.7665 140.137H48.7995V148.47H44.7665V140.137ZM61.1675 140.137H65.2005V148.47H61.1675V140.137ZM24.467 140.137H36.7005V144.372H28.6344V148.47H36.7005V152.568H28.6344V156.667H36.7005V160.765H24.467V140.137ZM12.2335 144.372H16.2665V156.803H12.2335V144.372ZM4.03302 156.667H12.2335V160.765H0V140H12.2335V144.235H4.03302V156.667Z",
    fill: "#F50D5A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_228",
    x1: 135,
    y1: 120,
    x2: 135,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#800FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833333,
    stopColor: "#F50D5A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1c6eb50da5c4b9fde0e0173da5e96ef6.svg";
export { ForwardRef as ReactComponent };